import {
  ADD_TO_TRASH,
  REMOVE_FROM_TRASH,
  REMOVE_ALL_FROM_TRASH,
} from "@/store/mutation-types";

const state = {
  analyteTrash: [],
  analysisTrash: [],
  attributeListsTrash: [],
  customerGrowersTrash: [],
  customerFieldsTrash: [],
  instrumentTrash: [],
  instrumentInstanceTrash: [],
  instrumentJigTrash: [],
  laboratoryTrash: [],
  prepProcessTrash: [],
  prepTaskTrash: [],
  qualityControlTrash: [],
  sampleTrash: [],
  sampleTypeTrash: [],
  staffTrash: [],
  submissionTrash: [],
  testPackageTrash: [],
  testProcessTrash: [],
  testTaskTrash: [],
  testPackageGroupTrash: [],
  turnaroundTrash: [],
  workGroupTrash: []
};

const getters = {
  analyteTrash: (state) => state.analyteTrash,
  analysisTrash: (state) => state.analysisTrash,
  attributeListsTrash: (state) => state.attributeListsTrash,
  customerGrowersTrash: (state) => state.customerGrowersTrash,
  customerFieldsTrash: (state) => state.customerFieldsTrash,
  instrumentTrash: (state) => state.instrumentTrash,
  instrumentInstanceTrash: (state) => state.instrumentInstanceTrash,
  instrumentJigTrash: (state) => state.instrumentJigTrash,
  laboratoryTrash: (state) => state.laboratoryTrash,
  prepProcessTrash: (state) => state.prepProcessTrash,
  prepTaskTrash: (state) => state.prepTaskTrash,
  qualityControlTrash: (state) => state.qualityControlTrash,
  sampleTrash: (state) => state.sampleTrash,
  sampleTypeTrash: (state) => state.sampleTypeTrash,
  submissionTrash: (state) => state.submissionTrash,
  staffTrash: (state) => state.staffTrash,
  testPackageTrash: (state) => state.testPackageTrash,
  testProcessTrash: (state) => state.testProcessTrash,
  testTaskTrash: (state) => state.testTaskTrash,
  testPackageGroupTrash: (state) => state.testPackageGroupTrash,
  turnaroundTrash: (state) => state.turnaroundTrash,
  workGroupTrash: (state) => state.workGroupTrash,
};

const mutations = {
  ADD_TO_TRASH: (state, { value, name }) => {
    const trashUpdate = [...state[`${name}Trash`]];
    trashUpdate.push(value);
    state[`${name}Trash`] = trashUpdate;
  },
  REMOVE_FROM_TRASH: (state, { id, name }) => {
    state[`${name}Trash`] = state[`${name}Trash`].filter(
      (element) => element.id !== id
    );
  },
  REMOVE_ALL_FROM_TRASH: (state, name) => {
    state[`${name}Trash`] = [];
  },
};

const actions = {
  PUT_TO_TRASH: ({ commit }, element) => {
    commit(ADD_TO_TRASH, element);
  },
  RESTORE_FROM_TRASH: ({ commit }, element) => {
    commit(REMOVE_FROM_TRASH, element);
  },
  CLEAR_TRASH: ({ commit }, name) => {
    commit(REMOVE_ALL_FROM_TRASH, name);
  },
};

export default {
  getters,
  mutations,
  actions,
  state,
};
